export const idCard = (val: any) => {
	if (
		/^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/.test(
			val
		)
	) {
		// tslint:disable-next-line: one-variable-per-declaration
		let vs = '1,0,x,9,8,7,6,5,4,3,2'.split(',')
		let ps = '7,9,10,5,8,4,2,1,6,3,7,9,10,5,8,4,2'.split(',')
		let ss = val.toLowerCase().split('')
		let r = 0
		for (let i = 0; i < 17; i++) {
			r += parseInt(ps[i]) * parseInt(ss[i])
		}
		// tslint:disable-next-line: triple-equals
		return vs[r % 11] == ss[17]
	}
}

export function passwordValidate(str: any) {
	var rC = {
		lW: /[a-z]/, //小写字母
		uW: /[A-Z]/, //大写字母
		nW: /[0-9]/, //数字
		sW: /[ ~!@#$^*_\-={}|[\];:,./]/, //特殊字符
	}

	if (str.length < 8 || str.length > 16) {
		return '请输入8-16位密码'
	} else {
		const tR = {
			l: rC.lW.test(str),
			u: rC.uW.test(str),
			n: rC.nW.test(str),
			s: rC.sW.test(str),
		}
		if (
			(tR.l && tR.u && tR.n) ||
			(tR.l && tR.u && tR.s) ||
			(tR.l && tR.n && tR.s) ||
			(tR.u && tR.n && tR.s)
		) {
			return true
		} else {
			return '请设置8-16位长度密码，包含数字、大小写字母及特殊符号中至少三种'
		}
	}
}
